import type { LinksFunction } from '@remix-run/node';

import { FREQUENTLY_ASKED_QUESTIONS } from './faq';

import styles from './dboo-faq.css?url';

export const links: LinksFunction = () => [{ rel: 'stylesheet', href: styles }];

const DbooFrequentlyAskedQuestions = () => {
  return (
    <div className="dboo-faq">
      <div className="container">
        <h2 className="dboo-faq__title">Frequently asked questions</h2>
        {FREQUENTLY_ASKED_QUESTIONS.map(({ title, description }) => (
          <details key={title.toLowerCase()} className="dboo-faq__item">
            <summary className="dboo-faq__item-title-wrapper">
              <span className="dboo-faq__item-title">{title}</span>
            </summary>
            <div className="dboo-faq__item-content">{description}</div>
          </details>
        ))}
      </div>
    </div>
  );
};

export default DbooFrequentlyAskedQuestions;
